export interface PageQueryParams {
  page?: number;
  size?: number;
}

export const validateUploadParamValue = (value: unknown) =>
  // undefined 이거나 빈 string 인 경우 안 됨
  !(value === undefined || (typeof value === 'string' && value.trim() === ''));
